module.exports = __webpack_public_path__ + "media/images/arrow-couriers-6dc09c6a.svg";